export default __webpack_public_path__ + "static/media/house-10.4d36bcc4.jpg";